
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/grow-network",
      function () {
        return require("private-next-pages/web/grow-network.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/grow-network"])
      });
    }
  